import { useTranslation } from 'react-i18next'

import Button from '@/components/Button/Button'
import ConfirmModal from '@/components/ConfirmModal'
import { toast } from '@/hooks/useToast'

import useArchiveCourse from '../mutations/useArchiveCourse'
import type { SimpleCourse } from '../types/simple-course'

type RemoveCourseModalProps = {
  course: SimpleCourse
  onOpenChange: (course: SimpleCourse | null) => void
  onArchiveSuccess?: (course: SimpleCourse) => void
}

const ArchiveCourseModal = (props: RemoveCourseModalProps) => {
  const { t } = useTranslation('coursesManagement')

  const { mutate: archiveCourse, isPending } = useArchiveCourse({
    onSuccess: () => {
      props.onArchiveSuccess?.(props.course)
      toast({
        variant: 'success',
        title: t('toast.course-archive-success', {
          COURSE: props.course.displayName
        })
      })
      props.onOpenChange(null)
    },
    onError: () => {
      toast({
        variant: 'error',
        title: t('toast.course-archive-error', {
          COURSE: props.course.displayName
        })
      })
    }
  })

  const handleOpenChange = (value: boolean) =>
    props.onOpenChange(value ? props.course : null)

  const handleConfirmClick = () => archiveCourse(props.course.id)

  return (
    <ConfirmModal
      header={t('header.archive-course')}
      subheader={
        <>
          <p>
            {t('text.want-to-archive-course', {
              COURSE: props.course.displayName
            })}
          </p>
          <p>{t('text.to-restore-contact-admin')}</p>
        </>
      }
      confirmButton={
        <Button
          variant="danger"
          onClick={handleConfirmClick}
          loading={isPending}
        >
          {t('button.archive')}
        </Button>
      }
      open
      onOpenChange={handleOpenChange}
    />
  )
}

export default ArchiveCourseModal
